import { render, staticRenderFns } from "./Ecosystems.vue?vue&type=template&id=22167e76&scoped=true"
import script from "./Ecosystems.vue?vue&type=script&lang=js"
export * from "./Ecosystems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22167e76",
  null
  
)

export default component.exports